// extracted by mini-css-extract-plugin
module.exports = {"footer":"TableListFooter_footer__3WMq4"};